'use client'

import React, { useEffect } from 'react';

export default function UtmBeacon() {
    useEffect(() => {
        try {
            const vidCookie = document.cookie.split('; ').find(c => c.startsWith('biddify_vid='));
            const vid = vidCookie?.split('=')[1];
            if (!vid) return;
            const storageKey = `utm_beacon_sent_${vid}`;
            if (sessionStorage.getItem(storageKey)) return;

            const body = {
                event_type: 'visit',
                data: window.location.pathname,
            };

            const url = '/api/analytics';

            if ('sendBeacon' in navigator) {
                const blob = new Blob([JSON.stringify(body)], { type: 'application/json' });
                const ok = navigator.sendBeacon(url, blob);
                if (ok) {
                    sessionStorage.setItem(storageKey, '1');
                    return;
                }
            }

            fetch(url, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(body),
                keepalive: true,
            }).then(() => {
                sessionStorage.setItem(storageKey, '1');
            }).catch(() => {
                // ignore errors; beacon is best-effort
            });
        } catch {
            // ignore errors
        }
    }, []);

    return null;
}


